import router from "@/Shared/routers/index";
import { callScannerBriefcaseFilter } from "@/Groups/Scanner/public/utils/callBriefcaseFilter";
import { callForecasterBriefcaseFilter } from "@/Groups/Forecasters/public/utils/launchBriefcaseFilter";
import { PATHS_NAME } from "@shared/routers/consts/pathsName";

export function reloadExternalContent(){
  const currentRoute = router.currentRoute.value;
  //Если открыт скриннер, то вызвать функцию обновления контента в скриннере
  if(currentRoute.name === PATHS_NAME.SCANNER){
    callScannerBriefcaseFilter();
  }else if(currentRoute.name === PATHS_NAME.FORECASTERS){
    callForecasterBriefcaseFilter();
  }
}